import React, { useCallback } from 'react';
import { StepConfig } from '../../types';
import { StepListStep } from './StepListStep';
interface Props {
    steps: StepConfig[];
    stepIndex: number;
    maxClickableStep: number;
    onStepSelect: (stepIndex: number) => void;
}

const StepList = (props: Props) => {
    return <div className="list-group">
        {props.steps.map((step, i) =>
            <StepListStep
                onStepSelect={props.onStepSelect}
                key={i}
                step={step}
                index={i}
                clickable={i <= props.maxClickableStep}
                isSelected={props.stepIndex === i} />
        )}
    </div>;
};



export default StepList;
